import React, { useContext, useState, useEffect } from "react";
import { ProductOptionStepsContext } from "../../../../Providers/ProductOptionStepsProvider";
import { ValidatorService } from "../../../../Helpers/Validators";
import StepContainer from "../../../../UX/StepContainer/StepContainer";

const PrintInside = props => {
    const {
        onUpdateProductOptionField,
        onCheckIfStepIsDone,
        onClearProductOptionField
    } = useContext(ProductOptionStepsContext);
    const step = props.step;

    const [totals, setTotals] = useState({});
    let total = 0;
    for (let key in totals) {
        total += totals[key];
    }

    const Buttons = (
        <>
            <button
                onClick={() => onOpenModal(step.id)}
                className="mr-4 lg:mr-6 mb-2 text-gray-600 hover:underline text-sm"
            >
                <i className="fas fa-info-circle" /> Meer informatie
            </button>
            <button
                onClick={() => onClearSelectedProductOptions(step.id)}
                className="mr-4 lg:mr-6 mb-2 text-gray-600 hover:underline text-sm "
            >
                <i className="fas fa-times" /> Verwijder keuze
            </button>
        </>
    );

    return (
        <StepContainer step={step} buttons={Buttons}>
            <div className="w-full bg-white p-4 rounded border border-gray-200">
                <div className="flex flex-wrap -mx-2">
                    {step.options.map(option => (
                        <React.Fragment key={option.value}>
                            {option.fields.map((field, index) => (
                                <NumberFields
                                    key={field.id}
                                    step={step}
                                    field={field}
                                    option={option}
                                    index={index}
                                    totals={totals}
                                    updateTotals={setTotals}
                                    onUpdateProductOptionField={
                                        onUpdateProductOptionField
                                    }
                                    onCheckIfStepIsDone={onCheckIfStepIsDone}
                                    onClearProductOptionField={
                                        onClearProductOptionField
                                    }
                                />
                            ))}
                            <div className="w-full px-2 mb-4">
                                <fieldset className="fieldset">
                                    Totaal aantal pagina's: <b>{total}</b>
                                </fieldset>
                            </div>

                            <div className="w-full px-2">
                                <button
                                    onClick={() => onCheckIfStepIsDone(step.id)}
                                    className="bg-yellow-200 text-yellow-900 px-4 py-2 text-white rounded mr-2 font-bold hover:bg-yellow-400"
                                >
                                    Volgende stap
                                </button>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </StepContainer>
        // <Card
        //     onOpenInfoModal={props.onOpenInfoModal}
        //     setRef={props.setRef}
        //     loading={step.loading}
        //     type={step.id}
        //     title={step.description}
        // >
        //     {step.options.map(option => (
        //         <React.Fragment key={option.value}>
        //             {option.fields.map((field, index) => (
        //                 <NumberFields
        //                     key={field.id}
        //                     step={step}
        //                     field={field}
        //                     option={option}
        //                     index={index}
        //                     totals={totals}
        //                     updateTotals={setTotals}
        //                     onUpdateProductOptionField={
        //                         onUpdateProductOptionField
        //                     }
        //                     onCheckIfStepIsDone={onCheckIfStepIsDone}
        //                     onClearProductOptionField={
        //                         onClearProductOptionField
        //                     }
        //                 />
        //             ))}
        //             <div className="cell large-12">
        //                 <fieldset className="fieldset">
        //                     Totaal aantal pagina's: <b>{total}</b>
        //                 </fieldset>
        //             </div>

        //             <div className="cell large-12">
        //                 <button
        //                     onClick={() => onCheckIfStepIsDone(step.id)}
        //                     className="button"
        //                 >
        //                     Volgende stap
        //                 </button>
        //             </div>
        //         </React.Fragment>
        //     ))}
        // </Card>
    );
};

export default PrintInside;

const NumberFields = ({
    field,
    option,
    step,
    onUpdateProductOptionField,
    onCheckIfStepIsDone,
    onClearProductOptionField,
    index,
    updateTotals,
    totals
}) => {
    const [value, setValue] = useState(0);
    const [isTouched, setIsTouched] = useState(false);
    const [errors, setErrors] = useState([]);
    let validators;
    if (field.validation) {
        validators = JSON.parse(field.validation);
    }

    useEffect(() => {
        if (field.value) {
            setValue(field.value);
        }
    }, []);

    const onChangeHandler = e => {
        updateTotals({
            ...totals,
            [index]: Number(e.target.value)
        });
        setValue(e.target.value);
        if (field.validation) {
            if (ValidatorService.checkValues(e.target.value, validators)) {
                onUpdateProductOptionField(
                    step.id,
                    option.value,
                    field.id,
                    e.target.value
                );
                setErrors([]);
            } else {
                onClearProductOptionField(
                    step.id,
                    option.value,
                    field.id,
                    e.target.value
                );
                if (
                    !ValidatorService.checkValues(e.target.value, validators) &&
                    isTouched
                ) {
                    setErrors(
                        ValidatorService.getErrors(e.target.value, validators)
                    );
                }
            }
        } else {
            onUpdateProductOptionField(
                step.id,
                option.value,
                field.id,
                e.target.value
            );
        }
    };

    const onBlurHandler = e => {
        onCheckIfStepIsDone(step.id);
        if (field.validation) {
            setIsTouched(true);
            if (!ValidatorService.checkValues(e.target.value, validators)) {
                setErrors(
                    ValidatorService.getErrors(e.target.value, validators)
                );
            } else {
                setErrors([]);
            }
        }
    };
    return (
        <React.Fragment key={field.id}>
            <div className="w-full md:w-1/2 px-2 mb-4">
                <label className="w-full mb-1" htmlFor="">
                    {field.label}
                </label>
                <input
                    className="bg-gray-200 h-10 p-2 w-full"
                    onBlur={onBlurHandler}
                    required={field.required === 1 ? true : false}
                    value={value}
                    onChange={onChangeHandler}
                    type={field.type}
                />
                {errors.length > 0 && (
                    <div className="border border-red-400 rounded p-4 mt-4">
                        {errors.map(
                            err => err && <p key={err.id}>{err.msg}</p>
                        )}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};
